import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./ModalPathologies.style";
import * as P from "../../../../../utils/pipes";

// Hooks
import ZaiaReaction from "../../../../zaiaComponents/zaiaReaction";
import ZaiaModalResponseContent from "../../../../zaiaComponents/zaiaModalResponseContent";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import ZaiaImage from "../../../../zaiaComponents/zaiaImage";
import useDoctorData from "../../../../../hooks/useDoctorData";
import { QUERY_GET_ALL_DEVICES, QUERY_GET_USER_TO_DEVICES } from "../../../../../graphql/queries/Devices";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import PathologyItem from "./components/deviceItem/PathologyItem";
import FlorenzSearchInput from "../../../../florenzComponents/florenceSearchInput";
import { MUTATION_DELETE_USER_TO_PATHOLOGY_BY_IDS, MUTATION_INSERT_USER_TO_PATHOLOGY } from "../../../../../graphql/mutations/Pathologies";
import { QUERY_GET_ALL_PATHOLOGIES_BY_PROCESS, QUERY_GET_USER_TO_PATHOLOGIES } from "../../../../../graphql/queries/Pathologies";


// Assets
const eventsCalendarEmpty = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/no-results.svg`;
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;

function ModalPathologies({
  patientInfo,
  setModalActive
}) {

  const { t, i18n: { language } } = useTranslation("global");
  const {doctorData} = useDoctorData();

  const [currentPathologies, setCurrentPathologies] = useState([]);
  const [availablePathologies, setAvailablePathologies] = useState([]);
  const [pathologiesToAdd, setPathologiesToAdd] = useState([]);
  const [pathologiesToRemove, setPathologiesToRemove] = useState([]);

  const [insertUserToPathology, { loading: insertUserToPathologyLoading }] = useMutation(MUTATION_INSERT_USER_TO_PATHOLOGY);
  const [deleteUserToPathology, { loading: deleteUserToPathologyLoading }] = useMutation(MUTATION_DELETE_USER_TO_PATHOLOGY_BY_IDS);  

  const { 
    data: allPathologiesData,
    loading: allPathologiesDataLoading,
    error: allPathologiesDataError,
  } = useQuery(
    QUERY_GET_ALL_PATHOLOGIES_BY_PROCESS,
    {
      variables: {
        processIds: patientInfo.userToProcesses.map((item) => item.process.id)
      }
    }
  );

  const { data: userPathologiesData, refetch: refetchUserPathologies } = useQuery(QUERY_GET_USER_TO_PATHOLOGIES, {
    variables: { 
      userId: patientInfo?.id
    },
  })    

  useEffect(() => {
    refetchUserPathologies();
  }, []);

  useEffect(() => {    
    const currentPathologiesTemp = userPathologiesData?.userToPatology.map(userPathology => {
      return {
        id: userPathology.id,
        name: userPathology.typePatologyVal.name,
        value: userPathology.typePatologyVal.value
      };
    });
    setCurrentPathologies(currentPathologiesTemp || []);

    const availablePathologiesTemp = allPathologiesData?.typePatology.filter((pathology) => !currentPathologiesTemp?.some(current => current.value === pathology.value)).map(pathology => {
      return {
        id: null,
        name: pathology.name,
        value: pathology.value
      };
    });
    setAvailablePathologies(availablePathologiesTemp || []);
  }, [userPathologiesData, allPathologiesData]);


  const [formSuccess, setFormSuccess] = useState(null); 
  const [inputText, setInputText] = useState('');

  const handleRemovePathology = (pathology) => {
    setCurrentPathologies(currentPathologies.filter(d => d !== pathology));
    setAvailablePathologies([...availablePathologies, pathology]);
  }

  const handleAddPathology = (pathology) => {   
    setAvailablePathologies(availablePathologies.filter(d => d !== pathology));
    setCurrentPathologies([...currentPathologies, pathology]);
  }

  useEffect(() => {
    const pathologiesToAddTemp = currentPathologies.filter(pathology => {
      return !userPathologiesData?.userToPatology?.some(d => d.typePatologyVal.value === pathology.value);
    }).map(pathology => {
      return {
        typePatology: pathology.value,
        userId: patientInfo?.id
      }
    });        

    setPathologiesToAdd(pathologiesToAddTemp || []);
  }, [availablePathologies]);

  useEffect(() => {
    const pathologiesToRemove = userPathologiesData?.userToPatology.filter(userPathology => {
      return !currentPathologies.some(current => current.value === userPathology.typePatologyVal.value)
    }).map(pathology => pathology.id);

    setPathologiesToRemove(pathologiesToRemove || []);
  }, [currentPathologies]);


  const getFilterText = (text) => {
    return inputText 
      ? String(P.removeAccent(text)).toLowerCase().includes(P.removeAccent(inputText).toLowerCase())
      : true
  }

  const handleAddPathologies = async () => {
    try {
      await insertUserToPathology({
        variables: {
          userToPatology: pathologiesToAdd,
        },
      });
      setFormSuccess(true);
    } catch (err) {
      console.log(err);
      setFormSuccess(false);
    }
  }

  const handleRemovePathologies = async () => {
    try {
      await deleteUserToPathology({
        variables: {
          userToPatologyIds: pathologiesToRemove,
        },
      });
      setFormSuccess(true);
    } catch (err) {
      console.log(err);
      setFormSuccess(false);
    }
  }

  const handleSubmit = () => {
    console.log("moster MF", pathologiesToAdd);
    console.log("moster MF REMOVE", pathologiesToRemove);

    if(pathologiesToAdd.length > 0) {
      handleAddPathologies();
    }

    if(pathologiesToRemove.length > 0) {
      handleRemovePathologies();
    }
  }

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.keyCode === 27) {
        setModalActive(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    // Don't forget to clean up
    return function cleanup() {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, []);  


  if(
    allPathologiesDataLoading || 
    insertUserToPathologyLoading ||
    deleteUserToPathologyLoading
  ) 
    return(
      <S.ModalPathologies>
        <div className="modal-background">
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaReaction
              widthimg={"150px"}
              zaiaImg={logoZaiaLoading}
              padding={"200px 0px"}
            />
          </div>
        </div>
      </S.ModalPathologies>
    )

  if(formSuccess)
    return(
      <S.ModalPathologies>
        <div className="modal-background" onClick={() => setModalActive(false)}>
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaModalResponseContent
              button1={() => setModalActive(null)}
              formSuccess={formSuccess}
              button1Text={t("globally.done")}
              title={t("aiNavigator.pathologies.pathologiesUpdated")}
            />
          </div>
        </div>
      </S.ModalPathologies>
    )

  if(formSuccess === false)
    return(
      <S.ModalPathologies>
        <div className="modal-background" onClick={() => setModalActive(false)}>
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaModalResponseContent
              button1={() => setModalActive(null)}
              formSuccess={formSuccess}
              title={t("globally.errorForm")}
                subtitle={t("aiNavigator.pathologies.errorUpdatingPathologies")}
              button1Text={t("globally.accept")}            
            />
          </div>
        </div>
      </S.ModalPathologies>
    )

  return (
    <S.ModalPathologies>
      <div className="modal-background" onClick={() => setModalActive(false)}>
      </div>
      <div className="modal-container">
        <div className="header">
          <div className="header__text">
            <div className="header__title">{t("aiNavigator.pathologies.managePathologies")}</div>
            <div className="header__patient">
              <ZaiaImage
                size={24}
                img={patientInfo?.picture}
                rounded={true}
              />
              <div className="header__patient-name">{`${patientInfo?.name} ${patientInfo?.lastname}`}</div>
              <div className="header__patient-process">{P.dataTranslation(patientInfo?.process?.processName, language)}</div>
            </div>
          </div>
          <div className="header__action" onClick={() => setModalActive(false)}>
            <i className="header__action-icon icon zaia-icono-cerrar"/>
          </div>
        </div>
        <div className="modal-content">
          <div className="modal-content__left">
            <div className="devices-linked">
              <div className="devices-linked__title">
                <div className="title">
                  {t("aiNavigator.pathologies.patientPathologies")}
                </div>
              </div>
              <div className="devices-linked__list">
                { currentPathologies.length === 0 
                  && <div className="devices-linked__list-empty">
                    {t("profile.smartDevices.noDevicesAdded")}
                  </div>
                }
                { 
                  currentPathologies
                  .map((pathology, index) => {
                    return (   
                      <div
                        key={index}
                        onClick={() => {
                          handleRemovePathology(pathology);
                        }}
                      >
                        <PathologyItem
                          pathology={pathology}
                          added={true}
                        />
                      </div>
                    )
                  }
                  )
                }
              </div>
            </div>
          </div>
          <div className="modal-content__right">
            <div className="devices-available">
              <div className="devices-available__title">
                <div className="title">
                  {t("aiNavigator.pathologies.pathologiesList")}
                </div>
                <div className="searcher">
                  <FlorenzSearchInput
                    placeholder={t("globally.search")}
                    forWhiteBackgroud={true}
                    getText={(text) => setInputText(text)}
                    borderanimation={false}
                  />
                </div>
              </div>
              <div className="devices-available__list">
                { allPathologiesDataLoading
                  ? <div className="devices-available__list-loading">
                      <ZaiaReaction
                        widthimg={"100px"}
                        zaiaImg={logoZaiaLoading}
                        padding={"100px 0px"}
                      />
                    </div>
                  : allPathologiesDataError
                    ? <div className="devices-available__list-error">
                        <ZaiaReaction
                          widthimg={"150px"}
                          zaiaImg={logoZaiaAlert}
                          padding={"100px 0px"}
                          text={t("aiNavigator.pathologies.errorLoadingPathologies")}
                        />
                      </div>
                    : availablePathologies?.length === 0
                      ? <div className="devices-available__list-empty">
                          <ZaiaReaction
                            widthimg={"150px"}
                            zaiaImg={eventsCalendarEmpty}
                            padding={"100px 0px"}
                            text={t("aiNavigator.pathologies.noPathologiesAvailable")}
                          />
                        </div>
                      : availablePathologies?.map((pathology, index) => 
                        (
                          getFilterText(P.dataTranslation(pathology?.name, language))
                        ) &&
                        (
                          <div
                            key={index}
                            onClick={() => {
                              handleAddPathology(pathology);
                            }} 
                          >
                            <PathologyItem
                              pathology={pathology}
                              added={false}
                            />  
                          </div>
                        )
                      )
                }
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="button-container">
            <FlorenzButton
              typeStyle={"secondaryWhite"}
              size="s"
              text={t("globally.cancel")}
              widthComplete={true}
              onClick={() => {
                setModalActive(false)
              }}
            />
          </div>
          <div className="button-container">
            <FlorenzButton
              disabled={
                pathologiesToAdd.length === 0 && pathologiesToRemove.length === 0
              }
              size="s"
              typeStyle={"success"}
              text={t("globally.save")}
              widthComplete={true}
              icon={
                (pathologiesToAdd.length === 0 && pathologiesToRemove.length === 0) && "zaia-i-lock-chat"
              }
              onClick={() => {
                handleSubmit()
              }}
            />
          </div>
        </div>
      </div>
    </S.ModalPathologies>
  );
}




export default ModalPathologies;
